export const PLAN_FREE = 'free';
export const PLAN_SCHOOL = 'school';
export const PLAN_DISTRICT = 'district';

export const PLAN_TYPES = {
    [PLAN_FREE]: 'Free Account (Trial Expired)',
    [PLAN_SCHOOL]: 'School Plan',
    [PLAN_DISTRICT]: 'District Plan'
};
